export const MAX_MESSAGE_PER_LIST = 1000; // range from 500-1000
export const MAX_CHAR_PER_MESSAGE = 10000; // 10 KB, facebook: 20k, slack: 12k
export const MAX_CHAR_PER_LIST = 500000; // 500 KB

export const INBOX_PREVIEW = 'INBOX_PREVIEW';
export const MESSAGE_DETAIL = 'MESSAGE_DETAIL';
export const CONVERSATION_DETAIL = 'CONVERSATION_DETAIL';
export const ORDER_DETAIL = 'ORDER_DETAIL';
export const ADD_NOTE = 'ADD_NOTE';
export const EDIT_NOTE = 'EDIT_NOTE';
export const REVIEW_SOURCES = 'REVIEW_SOURCES';
export const SHORTCUT_MODAL = 'SHORTCUT_MODAL';
export const CREATE_SHORTCUT = 'CREATE_SHORTCUT';
export const ADMIN = 'admin';
export const CUSTOMER = 'customer';
export const ANONYMOUS = 'anonymous';
export const GUEST = 'guest';
export const LIGHT_MODE = 'light_mode';
export const DARK_MODE = 'dark_mode';

export const MIN_COL_WIDTH = 260;
export const NAV_COL_WIDTH_THIN = 60;
export const NAV_COL_WIDTH = 202;
export const PROFILE_COL_WIDTH_THIN = 60;
export const PROFILE_COL_WIDTH = 370;
export const DEFAULT_DRAG_BAR = 6;

export const LIST_REACTIONS = [
  {
    value: 'heart',
    preview: 'https://cdnapps.avada.io/faq/chat-management/emoji/heart.png'
  },
  {
    value: 'joy-face',
    preview: 'https://cdnapps.avada.io/faq/chat-management/emoji/joy-face.png'
  },
  {
    value: 'open-mount',
    preview: 'https://cdnapps.avada.io/faq/chat-management/emoji/open-mount.png'
  },
  {
    value: 'cry',
    preview: 'https://cdnapps.avada.io/faq/chat-management/emoji/cry.png'
  },
  {
    value: 'pounting-face',
    preview: 'https://cdnapps.avada.io/faq/chat-management/emoji/pounting-face.png'
  },
  {
    value: 'thump-up',
    preview: 'https://cdnapps.avada.io/faq/chat-management/emoji/thump-up.png'
  }
];

export const COLOR_CUSTOMER_AVATAR = [
  {color: '#791A79', backgroundColor: '#FBCFFB', fontWeight: '450'},
  {color: '#8D0448', backgroundColor: '#FED1DD', fontWeight: '450'},
  {color: '#0C5132', backgroundColor: '#38FAA3', fontWeight: '450'},
  {color: '#095346', backgroundColor: '#92EDDE', fontWeight: '450'}
];

export const TAB_INBOX = '/inbox';
export const TAB_SETTINGS = '/settings';
export const TAB_SETTINGS_DETAIL = '/settings/detail';
export const TAB_SETTINGS_DETAIL_INBOX_SETTINGS = '/settings/detail/inbox-settings';
export const TAB_SETTINGS_APPEARANCE = '/settings/appearance';
export const TAB_SETTINGS_INBOX_SETTINGS = '/settings/appearance/inbox';
export const TAB_SETTINGS_AVAILABILITY = '/settings/chat-availability';
export const TAB_SETTINGS_NOTIFICATION = '/settings/notifications';
export const TAB_SETTINGS_SHORTCUT = '/settings/shortcut';
export const TAB_SETTINGS_SHORTCUT_CREATE = '/settings/shortcut/create';
export const TAB_TRANSLATION = '/settings/translations';
export const TAB_CHANNEL_EMAIL = '/settings/channels/email';
export const TAB_CHANNEL_FACEBOOK = '/settings/channels/facebook';
export const TAB_INTEGRATION_JOY = '/settings/integrations/joy';

export const SUBSCRIBED = 'SUBSCRIBED';
export const UNSUBSCRIBED = 'UNSUBSCRIBED';
export const SKIP = 'SKIP';

export const TIME_UNSUB_NEW_MESSAGE = 15 * 60 * 1000;
